import { Link } from "react-router-dom";

const linkGroups = [
  {
    title: "快速导航",
    links: [
      { label: "首页", to: "/" },
      { label: "剧情介绍", to: "/story" },
      { label: "影评与专题", to: "/reviews" },
      { label: "最新资讯", to: "/news" },
      { label: "关于我们", to: "/about" },
    ],
  },
  {
    title: "热门内容",
    links: [
      { label: "在线观看演示", to: "/watch" },
      { label: "深度影评", to: "/reviews" },
      { label: "幕后花絮", to: "/news" },
      { label: "影展资讯", to: "/news" },
      { label: "友情链接", to: "/about" },
    ],
  },
];

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "B站" },
  { icon: "ri-youtube-fill", label: "视频号" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-foreground-950">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-fill text-xl" />
              </span>
              <span className="font-heading text-xl font-bold whitespace-nowrap">色戒在线观看</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-100/80 max-w-md">
              一个专注于经典电影《色戒》的影视门户，提供剧情介绍、深度影评与影视资讯。本站内容均为演示示例，播放功能为前端模拟，不提供真实视频资源。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {socials.map((s) => (
                <button
                  key={s.label}
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-800 text-accent-400 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`} />
                </button>
              ))}
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base font-semibold text-accent-400">{group.title}</h4>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-primary-100/80 hover:text-accent-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-100/60">
          <p>© 2026 色戒在线观看 · 本站为演示站点，内容均为虚构示例，仅供学习交流使用。</p>
          <p className="flex items-center gap-4">
            <span className="whitespace-nowrap">隐私政策</span>
            <span className="whitespace-nowrap">免责声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}